// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__eTMbz","rootSmall":"AddTileButton_rootSmall__3XMyn"};